<template>
    <v-card class="ma-2 english-level-card">
        <v-card-title class="card-employee-title english-card-title">
            English level
        </v-card-title>
        <v-card-text class="english-text-card">
            <v-flex class="english-level-card flex-container">
                <v-select content-class="english-level" v-bind:items="englishLevelList" class="select-card english-level-select"
                    v-model="englishLevel" label="English level" single-line bottom :disabled="!isEditEnabled"></v-select>
            </v-flex>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'EmployeeEnglishLevel',
        data() {
            return {
                englishLevelList: [
                    { text: 'Beginner', value: 1 },
                    { text: 'Elementary (A1)', value: 2 },
                    { text: 'Pre-Intermediate (A2)', value: 3 },
                    { text: 'Intermediate (B1)', value: 4 },
                    { text: 'Upper-Intermediate (B2)', value: 5 },
                    { text: 'Advanced (C1)', value: 6 }
                ]
            };
        },
        computed: {
            ...mapGetters({
                employee: 'getEmployee'
            }),
            englishLevel: {
                get() {
                    return this.$store.state.employees.employee.englishLevel;
                },
                set(value) {
                    this.$store.dispatch('editEmployeeEnglish', value);
                }
            },
            isEditEnabled() {
                return !this.employee.archived;
            }
        }
    };
</script>

<style scoped>
    .menu__content.menu__content--select.menuable__content__active {
        max-height: 304px !important;
    }
    .english-level-select >>> .input-group__selections__comma {
        margin-top: 6px;
    }
    .flex-container {
        padding: 18px 0 0 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/reusable/EmployeeEnglishLevel.vue